import { render, staticRenderFns } from "./DetallePedido.vue?vue&type=template&id=3db03bf7"
import script from "./DetallePedido.vue?vue&type=script&lang=js"
export * from "./DetallePedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports